import React from 'react';
import { useState } from 'react';
import { Box, Drawer, Button, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


const SIDEBAR_WIDTH = {xs: "0", lg: "400px", xl: "500px"};
const DRAWER_WIDTH = {xs: "100vw", sm: "70vw"};


const BUTTON_STYLE = {
    color: 'white',
    borderColor: 'white',
    '&:hover': {borderColor: '#eee'},
    position: 'fixed',
    display: { xs: 'block', lg: 'none' },
    right: {sm: "15px", xs: "10px"},
    top: {sm: "15px", xs: "10px"},
    zIndex: (theme) => theme.zIndex.drawer + 10, // above nav menu  FIXME which item is correct?
}

const MainContent = styled('main')(({ theme }) => ({
    flexGrow: 1,
    p: 3,
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    maxWidth: '100%',
}));


export const HelpingDrawerLayout = ({
    drawerContent: DrawerContent,
    sidebarWidth,
    drawerWidth,
    buttonText,
    children,
}) => {
    const [drawerOpen, setDrawerOpen] = useState(false);

    if (sidebarWidth === undefined) { sidebarWidth = SIDEBAR_WIDTH; }
    if (drawerWidth === undefined) { drawerWidth = DRAWER_WIDTH; }

    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen);
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <Drawer
                variant="temporary"
                anchor="right"
                open={drawerOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: { xs: 'block', lg: 'none' },
                    zIndex: (theme) => theme.zIndex.drawer - 1,
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: drawerWidth,
                    },
                }}
            >
                <Toolbar /> {/* top padding under the toolbar */}
                <DrawerContent drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
            </Drawer>
            <Drawer
                variant="permanent"
                anchor="right"
                sx={{
                    display: { xs: 'none', lg: 'block' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: sidebarWidth },
                }}
            >
                <Toolbar /> {/* top padding under the toolbar */}
                <DrawerContent drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
            </Drawer>

            <MainContent
                sx={{
                    marginRight: sidebarWidth,
                }}
            >
                {drawerOpen ? (
                    <IconButton onClick={handleDrawerToggle} sx={{
                        justifyContent: 'flex-end',
                        lineHeight: "0px",
                        ...BUTTON_STYLE,
                    }}>
                        <CloseIcon />
                    </IconButton>
                ) : (
                    <Button
                        variant="outlined"
                        onClick={handleDrawerToggle}
                        color="secondary"
                        sx={BUTTON_STYLE}
                    >
                        {buttonText}
                    </Button>
                )}
                {children}
            </MainContent>
        </Box>
    );
}
